import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HeaderService } from '../services/header.service';
import { NotificationService } from '../services/notification.service';
import { error } from '@angular/compiler/src/util';

@Component({
  selector: 'app-customer-support',
  templateUrl: './customer-support.component.html',
  styleUrls: ['./customer-support.component.scss']
})
export class CustomerSupportComponent implements OnInit {
  customerSuportLoader:boolean = false;
  supportForm: FormGroup;

  constructor(private fb: FormBuilder, private headerService:HeaderService, private notificationService:NotificationService) {
    this.supportForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit() {
  }
  
  get email() {
    return this.supportForm.get('email');
  }

  get message() {
    return this.supportForm.get('message');
  }

  onSubmit() {
    this.customerSuportLoader = true; 
    if (this.supportForm.valid) {
      this.headerService.customerSupport(this.supportForm.value).subscribe((response:any)=>{
        this.customerSuportLoader = false;
        this.notificationService.showNotification("success", response.message);
        this.supportForm.reset();
      }, (error)=>{
        this.customerSuportLoader = false;
        this.notificationService.showNotification("error", error.message);
      })
    } else {
      this.supportForm.markAllAsTouched();
      this.customerSuportLoader = false;
    }
  }



}
